import type { LandingPageQuery, LandingPageQueryVariables } from 'src/types';
import { usePageQuery } from 'src/hooks/use-page-query';
import landingPageQuery from '../query.graphql';

export function useLandingPageQuery(variables: LandingPageQueryVariables) {
  return usePageQuery<LandingPageQuery>({
    query: landingPageQuery,
    routeName: 'start',
    variables,
  });
}
